/**
 * @typedef {Object} SvgPlacesStorageModelData
 * @property {string} svg
 * @property {import("../api/rest/event").Price[]} prices
 * @property {import("../api/rest/event").Zone[]} zones
 * @property {number} eventId
 * @property {number} time
 * @property {string} version
 * @property {Object<string, string[]>} places
 * @property {Object<string, import("../api/rest/event").PlacesParamsItem} places_params - список мест с параметрами где ключ сид
*/

/**
 * @typedef {Object} SvgPlacesData
 * @property {string} svg
 * @property {import("../api/rest/event").Zone[]} zones
 * @property {Object<string, string[]>} places
 * @property {Object<string, import("../api/rest/event").PlacesParamsItem} places_params - список мест с параметрами где ключ сид
*/

export class SvgPlacesStorageModel {
  constructor() {
    this.svg = null;
    this.prices = [];
    this.zones = [];
    this.eventId = null;
    this.time = null;
    this.version = null;

    /**
     * @type {Object<string, string[]>} - список сидов сгруппированных по зоне
    */
    this.places = {};

    /**
     * @type {Object<string, import("../api/rest/event").PlacesParamsItem>}
    */
    this.places_params = {};
  }

  /**
   * @param {number} eventId
   * @param {SvgPlacesStorageModelData} data
  */
  setAndValidateDataByEventId(eventId, data) {
    /* Если в сторидже есть данные этого мероприятия то загружаем их в модель */
    if (eventId === data.eventId) return this.insertData(data);
    
    /* В сторидже хранятся данные другого мероприятия тогда сохраняем в модель только свг а остальное очищаем */
    this.insertData({
      svg: data.svg,
      places: data.places,
      version: data.version,
      places_params: data.places_params,
      eventId: eventId
    });
  }

  /**
   * @param {Object} param
   * @param {('busy' | 'free')} param.type
   * @param {import("../api/rest/event").Price[]} param.values
  */
  setPricesByActualPlaces({ type, values }) {
    if (type === 'busy') {
      this.prices = this.getPricesByBusyTypePlaces(values);
    } else {
      this.prices = values;
    }
  }

  /**
   * @param {import("../api/rest/event").Price[]} busyPlaces
   * @return {Array<{ id: string, z: number }>}
   */
  getPricesByBusyTypePlaces(busyPlaces) {
    let prices = [];
    Object.keys(this.places).map((zoneId) => {
      this.places[zoneId].map((placeId) => {
        if (busyPlaces.filter((price) => price.id === placeId).length > 0) return false;
        prices.push({
          id: placeId,
          z: Number(zoneId),
        });
      });
    });
    return prices;
  }

  isValid() {
    if (!this.svg) return false;
    if (!(typeof this.svg === 'string' || this.svg instanceof String)) return false;
    if (!(typeof this.version === 'string' || this.version instanceof String)) return false;
    if (!Array.isArray(this.prices)) return false;
    if (!Array.isArray(this.zones)) return false;
    if (!Number.isInteger(this.eventId)) return false;
    if (!(typeof this.places === 'object' && this.places !== null)) return false;
    
    return true;
  }

  /** @param {SvgPlacesStorageModelData} data */
  insertData(data = {}) {
    this.svg = data.svg || null;
    this.prices = data.prices || [];
    this.places = data.places || {};
    this.places_params = data.places_params || {};
    this.zones = data.zones || [];
    this.eventId = data.eventId || null;
    this.time = data.time || null;
    this.version = data.version || null;
  }

  /** @returns {SvgPlacesData} */
  getSvgPlacesData() {
    return {
      svg: this.svg,
      places: this.places,
      places_params: this.places_params,
      zones: this.zones
    }
  }

  /** @returns {SvgPlacesStorageModelData} */
  getToStoreData() {
    return {
      svg: this.svg,
      prices: this.prices,
      places: this.places,
      places_params: this.places_params,
      zones: this.zones,
      eventId: this.eventId,
      version: this.version,
      time: +new Date(),
    }
  }
}
